<template>
  <svg
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M13.25 2.4a.75.75 0 0 0 0 1.5H17a.75.75 0 0 0 0-1.5h-3.75ZM15.13 24.9a1.37 1.37 0 1 0 0 2.75 1.37 1.37 0 0 0 0-2.75Z" fill="currentColor" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.63 0A2.63 2.63 0 0 0 5 2.63v25a2.63 2.63 0 0 0 2.63 2.62h15a2.63 2.63 0 0 0 2.62-2.63v-25A2.63 2.63 0 0 0 22.62 0h-15ZM6.5 2.63C6.5 2 7 1.5 7.63 1.5h15c.62 0 1.12.5 1.12 1.13V4.9H6.5V2.62Zm0 19.77v-16h17.25v16H6.5Zm0 5.23V23.9h17.25v3.73c0 .62-.5 1.12-1.13 1.12h-15c-.61 0-1.12-.5-1.12-1.13Z"
      fill="currentColor"
    />
  </svg>
</template>
